var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19706 3.80078L11.6971 6.30078H20.9056C21.6259 6.30078 22.249 6.64114 22.6466 7.15574C23.0442 7.67034 23.2162 8.35917 23.0344 9.05611L20.5562 18.5561C20.4772 18.8588 20.3375 19.133 20.1521 19.3668C19.7443 19.8813 19.1157 20.2008 18.4274 20.2008H3.2C1.98497 20.2008 1 19.2158 1 18.0008V6.00078C1 4.78576 1.98497 3.80078 3.2 3.80078H9.19706ZM18.4274 19.0008H3.54962C2.87809 19.0008 2.39742 18.3521 2.59294 17.7096L5.48425 8.20962C5.6124 7.78855 6.00079 7.50078 6.44092 7.50078H20.9056C21.279 7.50078 21.5949 7.70198 21.7669 7.99238C21.8965 8.21129 21.9443 8.48088 21.8733 8.7532L19.395 18.2532C19.3663 18.3633 19.3199 18.465 19.2594 18.5558C19.0777 18.828 18.7687 19.0008 18.4274 19.0008Z",
    fill: "#666E7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6953 9.50499L18.1899 13L14.6953 16.4945L13.7054 15.5046L15.51 13.6999H11.2V12.2999H15.5102L13.7053 10.4949L14.6953 9.50499Z",
    fill: "#666E7A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpen);
export default __webpack_public_path__ + "static/media/icon_open.5c1c6c9fc3d275d93231792743ad565c.svg";
export { ForwardRef as ReactComponent };